import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService, User } from '../../core/services/auth.service';
import { ThemeService, Theme } from '../../core/services/theme.service';
import { SidebarService } from '../../core/services/sidebar.service';
import { VisibilityService } from '../../core/services/visibility.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  currentUser: User | null = null;
  currentTheme: Theme = 'dark';
  currentLang = 'pt-br';

  private readonly destroy$ = new Subject<void>();

  constructor(
    private auth: AuthService,
    private themeService: ThemeService,
    private sidebarService: SidebarService,
    private translate: TranslateService,
    public visibilityService: VisibilityService
  ) {}

  ngOnInit(): void {
    this.auth.currentUser$.pipe(takeUntil(this.destroy$)).subscribe((user) => {
      this.currentUser = user;
      if (user?.preferencias) {
        this.currentLang = user.preferencias.idioma;
      }
    });

    this.themeService.theme$.pipe(takeUntil(this.destroy$)).subscribe((theme) => {
      this.currentTheme = theme;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggleTheme(): void {
    this.themeService.toggleTheme();
    if (this.currentUser) {
      this.auth.updateProfile({
        preferencias: { tema: this.themeService.getCurrentTheme() },
      }).subscribe();
    }
  }

  switchLanguage(lang: string): void {
    this.currentLang = lang;
    this.translate.use(lang);
    if (this.currentUser) {
      this.auth.updateProfile({
        preferencias: { idioma: lang },
      }).subscribe();
    }
  }

  toggleSidebar(): void {
    this.sidebarService.toggle();
  }

  logout(): void {
    this.auth.logout();
  }
}
